import type { ObjectPageHeader, ObjectPageLayout } from '../controls';
import { v4 } from '@sap/ux-specification-types';
import {
    pageLayoutInformation,
    childId,
    syncRule,
    validity,
    descriptionSrcURL
} from '../../../common/decoration/decorators';
import { getSettingsPathForPage } from '../../application';

@pageLayoutInformation({
    id: `${v4.FE_TEMPLATE_V4_OBJECT_PAGE}.view.Details`,
    pageId: v4.FE_TEMPLATE_V4_OBJECT_PAGE
})
export class ObjectPage implements v4.ObjectPageConfigV4 {
    @childId('header')
    header?: ObjectPageHeader;

    @childId('layout')
    layout?: ObjectPageLayout;

    @syncRule({
        manifest: {
            path: (pageName: string[]): string => getSettingsPathForPage(pageName)
        }
    })
    @validity({
        since: '1.84.0'
    })
    @descriptionSrcURL('https://ui5.sap.com/sdk/#/topic/f26d42bea11c4deda82c7a2e00c9bc05')
    variantManagement?: v4.VariantManagementTypeObjectPage;

    @syncRule({
        manifest: {
            path: (pageName: string[]): string => getSettingsPathForPage(pageName)
        }
    })
    @validity({
        since: '1.144.0'
    })
    @descriptionSrcURL('https://ui5.sap.com/#/topic/ac035701f0f94bcca2d051bba9f1880d')
    enableLazyLoading?: boolean;

    @childId('sections')
    sections?: v4.GenericSections | v4.CustomSections;

    footer?: v4.ObjectPageFooter<v4.ObjectPageFooterActions>;
}
